
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider, styled } from "@mui/material/styles";
import { QueryParamProvider } from "use-query-params";
import { PusherProvider } from "components/PusherProvider";
import { MaterialDesignContent, SnackbarProvider } from "notistack";
import { configure } from "mobx";

import { theme } from "./theme";
import { AppStoreProvider, HubProvider, AuthenticatedApp } from "components";
import SetStore from "./views/SetStore";
import ManageApp from "./views/Manage";
import Error404 from "./views/Error404";
import pusherConfig from "./pusherConfig";
import { FirestoreProvider } from "./hooks";

// import 'react-perfect-scrollbar/dist/css/styles.css'
import "./assets/scss/main.scss";

// No longer needed with tss-react

configure({
	enforceActions: "never",
});

const StyledMaterialDesignContent = styled(MaterialDesignContent)({
	fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif !important',
});

function App() {
	return (
		<FirestoreProvider>
			<AppStoreProvider>
				<HubProvider>
					<StyledEngineProvider injectFirst>
						<ThemeProvider theme={theme}>
							<Router>
								<PusherProvider {...pusherConfig.client}>
									<QueryParamProvider ReactRouterRoute={Route}>
										<SnackbarProvider
										maxSnack={3}
										Components={{
											success: StyledMaterialDesignContent,
											error: StyledMaterialDesignContent,
											warning: StyledMaterialDesignContent,
											info: StyledMaterialDesignContent,
										}}
									>
											<Switch>
												<Route exact component={SetStore} path="/set-store" />
												<AuthenticatedApp
													exact
													component={ManageApp}
													path="/"
												/>
												<Route component={Error404} />
											</Switch>
										</SnackbarProvider>
									</QueryParamProvider>
								</PusherProvider>
							</Router>
						</ThemeProvider>
					</StyledEngineProvider>
				</HubProvider>
			</AppStoreProvider>
		</FirestoreProvider>
	);
}

export default App;
